import React, { useState, useEffect } from 'react';
import { Typography, Box } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import styles from './FAQ.module.css';

const FAQPage = () => {
  const [faq, setFaq] = useState('');

  useEffect(() => {
    fetch('/FAQs.md')
      .then(response => response.text())
      .then(text => setFaq(text));
  }, []);

  return (
    <Box className={styles.container}>
      <Typography variant="h4" component="h1" gutterBottom align="center" className={styles.heading}>
        Frequently Asked Questions
      </Typography>
      <ReactMarkdown className={styles.markdown}>{faq}</ReactMarkdown>
    </Box>
  );
};

export default FAQPage; 